import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth, authState } from '@angular/fire/auth';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { from, map, of, switchMap, take } from 'rxjs';
import { environment } from '../../../environments/environment';

export const ownerGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const firestore = inject(Firestore);
  const router = inject(Router);
  const ownerEmail = environment.ownerEmail.toLowerCase();

  return authState(auth).pipe(
    take(1),
    switchMap((user) => {
      if (!user) {
        return of(router.createUrlTree(['/login']));
      }

      const emailIsOwner = (user.email ?? '').toLowerCase() === ownerEmail;
      if (emailIsOwner) {
        return of(true);
      }

      return from(getDoc(doc(firestore, `users/${user.uid}`))).pipe(
        map((snap) => {
          const role = snap.data()?.['role'];
          return role === 'owner' ? true : router.createUrlTree(['/']);
        }),
      );
    }),
  );
};
